const constants = async () => {
    return {
             'google_id': '749296163786-c75bu38p9kn80o79fcqs5serd36tsn8k.apps.googleusercontent.com'
           }
};
export { constants };

